import { FC } from "react"
import { Patient } from "../../types/Patient"
import { toTitleCase } from "../../utils/str"

interface PatientOverviewProps {
  patient: Patient
}

export const PatientOverview: FC<PatientOverviewProps> = ({ patient }) => {
  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-900">Overview</h3>
      <div className="mt-2">
        <dl className="grid grid-cols-1 gap-x-4 gap-y-3 sm:grid-cols-2">
          <div className="sm:col-span-1">
            <dt className="text-sm font-medium text-gray-500">Patient</dt>
            <dd className="mt-1 text-sm text-gray-900">{patient.name ?? "-"}</dd>
          </div>
          <div className="sm:col-span-1">
            <dt className="text-sm font-medium text-gray-500">Patient ID</dt>
            <dd className="mt-1 text-sm text-gray-900">{patient.clientId ?? "-"}</dd>
          </div>
          <div className="sm:col-span-1">
            <dt className="text-sm font-medium text-gray-500">Owner</dt>
            <dd className="mt-1 text-sm text-gray-900">{patient.owner ?? "-"}</dd>
          </div>
          <div className="sm:col-span-1">
            <dt className="text-sm font-medium text-gray-500">Email</dt>
            <dd className="mt-1 text-sm text-gray-900">{patient.email ?? "-"}</dd>
          </div>
          <div className="sm:col-span-1">
            <dt className="text-sm font-medium text-gray-500">Updated at</dt>
            <dd className="mt-1 text-sm text-gray-900">
              {new Intl.DateTimeFormat("en-US", {
                month: "short",
                day: "2-digit",
                year: "numeric",
              }).format(new Date(patient.updatedAt))}
            </dd>
          </div>
          {Object.entries(patient?.metadata ?? {}).map(([key, value], i) => (
            <div className="sm:col-span-1" key={i}>
              <dt className="text-sm font-medium text-gray-500">{toTitleCase(key)}</dt>
              <dd className="mt-1 text-sm text-gray-900">{value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  )
}
